import { ROUTES } from "../../appConfig";

import { getMainUrl } from "../../utils/page";

import { UserState } from "./types";

export const INITIAL_STATE: UserState = {
  is_user_requested: false,
  emailNotConfirmed: false,
  lastProjects: [],
};

export const SIGN_IN_NEXT_ABLE_ROUTES = [getMainUrl(), ROUTES.SHARED, ROUTES.PRESENTATION, ROUTES.TOOLS];
